import { render, staticRenderFns } from "./otherQualifications.vue?vue&type=template&id=e5aaf6ae&scoped=true"
import script from "./otherQualifications.vue?vue&type=script&lang=js"
export * from "./otherQualifications.vue?vue&type=script&lang=js"
import style0 from "./otherQualifications.vue?vue&type=style&index=0&id=e5aaf6ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5aaf6ae",
  null
  
)

export default component.exports